:root {
    --success-color: #48BB78;
    --success-light: #C6F6D5;
    --primary-color: #635BFF;
    --text-primary: #2D3748;
    --text-secondary: #718096;
    --border-color: #E2E8F0;
    --background-light: #F7F9FC;
  }
  
  .container {
    min-height: 100vh;
    background-color: var(--background-light);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
  }
  
  .card {
    background-color: white;
    border-radius: 12px;
    padding: 40px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    text-align: center;
    max-width: 500px;
    width: 100%;
    border: 1px solid var(--border-color);
  }
  
  .checkmarkCircle {
    width: 80px;
    height: 80px;
    background-color: var(--success-color);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 24px;
    animation: scaleIn 0.6s ease-out;
  }
  
  .checkmark {
    color: white;
    font-size: 36px;
    font-weight: bold;
  }
  
  .title {
    font-size: 28px;
    font-weight: 600;
    color: var(--text-primary);
    margin: 0 0 16px 0;
  }
  
  .message {
    font-size: 16px;
    color: var(--text-secondary);
    margin: 0 0 32px 0;
    line-height: 1.5;
  }
  
  .orderDetails {
    background-color: var(--background-light);
    border-radius: 8px;
    padding: 24px;
    margin: 24px 0;
    text-align: left;
    border: 1px solid var(--border-color);
  }
  
  .orderDetails h2 {
    margin: 0 0 16px 0;
    font-size: 20px;
    color: var(--text-primary);
    text-align: center;
  }
  
  .orderDetails p {
    margin: 8px 0;
    color: var(--text-secondary);
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .orderDetails strong {
    color: var(--text-primary);
  }
  
  .actions {
    margin-top: 32px;
  }
  
  .button {
    background-color: var(--primary-color);
    color: white;
    border: none;
    padding: 12px 24px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 500;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
  }
  
  .button:hover {
    background-color: #574ce0;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(99, 91, 255, 0.3);
  }
  
  /* Animation for the checkmark */
  @keyframes scaleIn {
    0% {
      transform: scale(0);
      opacity: 0;
    }
    50% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
  
  /* Responsive design */
  @media (max-width: 768px) {
    .container {
      padding: 16px;
    }
    
    .card {
      padding: 24px;
    }
    
    .title {
      font-size: 24px;
    }
    
    .checkmarkCircle {
      width: 60px;
      height: 60px;
    }
    
    .checkmark {
      font-size: 28px;
    }
  }